module.exports = __webpack_public_path__ + "img/147.a714e765.jpg";